/* Minimal <image-slot> for the Cravy landing page.
   The design tool's original is a 63KB editor component; on a live store we
   only need it to render its `src` image filling the slot.
   Descriptive text (alt) for each picture: an explicit alt attribute wins, then the
   list below (by slot id), then a name worked out from the placeholder text. */
(function () {
  if (window.customElements && customElements.get('image-slot')) return;
  var ALT_BY_ID = {
    'story-01': 'Freshly picked potatoes from the farm',
    'story-02': 'Cravy fries with a golden crispy coating on the production line',
    'story-03': 'Cravy Fries production facility where fries are frozen at peak freshness',
    'social-1': 'Person holding up a white Cravy Fries t-shirt against a blue sky',
    'social-2': 'Hand holding a Cravy Fries pack over a plate of golden fries in a cosy red-lit room',
    'social-3': 'Friends playing video games with a big bowl of Cravy fries',
    'social-4': 'Cravy Fries pack pouring crispy fries into an air fryer basket',
    'social-5': 'Person enjoying Cravy fries at the dinner table'
  };
  function altFor(el) {
    var a = el.getAttribute('alt');
    if (a) return a;
    if (ALT_BY_ID[el.id]) return ALT_BY_ID[el.id];
    var ph = el.getAttribute('placeholder') || '';
    var m = ph.match(/^Drop (.+) packaging PNG$/);
    if (m) return 'Cravy ' + m[1] + ' pack';
    return '';
  }
  class ImageSlot extends HTMLElement {
    connectedCallback() { this._render(); }
    static get observedAttributes() { return ['src']; }
    attributeChangedCallback() { if (this.isConnected) this._render(); }
    _render() {
      const src = this.getAttribute('src') || '';
      const fit = this.getAttribute('fit') || 'cover';
      const radius = this.getAttribute('radius');
      this.style.display = 'block';
      this.style.overflow = 'hidden';
      if (radius) this.style.borderRadius = radius + 'px';
      this.innerHTML = '';
      if (!src) return;
      const img = document.createElement('img');
      img.src = src;
      img.alt = altFor(this);
      img.loading = 'lazy';
      img.style.cssText = 'width:100%;height:100%;object-fit:' + fit + ';display:block';
      this.appendChild(img);
    }
  }
  customElements.define('image-slot', ImageSlot);
})();
